import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";

import Checkout from "features/Checkout";
import HomeDashboard from "features/Home/HomeDahsboard";
import ProfileDashboard from "features/Profile";
import Categories from "features/Profile/Categories";
import ReportTemplates from "features/Profile/ReportTemplates";
import ReportTemplate from "features/Profile/ReportTemplates/ReportTemplate";
import Templates from "features/Profile/Templates";
import SessionDashboard from "features/Session/SessionDashboard";
import Subscription from "features/Subscription";

import { ROUTES } from "utils/constants";

import AuthCallback from "components/AuthCallback";
import PrivateRoute from "components/PrivateRoute";

import MainLayout from "layouts/MainLayout";

export default function Routes() {
  const router = createBrowserRouter([
    {
      path: "/callback",
      element: <AuthCallback />,
    },
    {
      element: <PrivateRoute />,
      children: [
        {
          path: ROUTES.HOME,
          element: <MainLayout />,
          children: [
            {
              path: ROUTES.HOME,
              element: <HomeDashboard />,
            },
            {
              path: ROUTES.SESSION,
              element: <SessionDashboard />,
            },
            {
              path: ROUTES.SESSION_VIEW,
              element: <SessionDashboard />,
            },
            {
              path: ROUTES.PROFILE,
              element: <ProfileDashboard />,
            },
            {
              path: ROUTES.PROFILE_CATEGORIES,
              element: <Categories />,
            },
            {
              path: ROUTES.PROFILE_TEMPLATES,
              element: <Templates />,
            },
            {
              path: ROUTES.PROFILE_REPORT_TEMPLATES,
              element: <ReportTemplates />,
            },
            {
              path: ROUTES.PROFILE_REPORT_TEMPLATE,
              element: <ReportTemplate />,
            },
            {
              path: ROUTES.PROFILE_REPORT_TEMPLATE_NEW,
              element: <ReportTemplate />,
            },
            {
              path: ROUTES.SUBSCRIPTION,
              element: <Subscription />,
            },
            {
              path: ROUTES.CHECKOUT,
              element: <Checkout />,
            },
            {
              path: "*",
              element: <Navigate to={ROUTES.HOME} replace />,
            },
          ],
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}
